import { httpGet } from './api.service';
import { SearchEntitiesRequest } from '../requestModels/searchEntitiesRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { SearchResult } from '../types/SearchResult';

const searchEntities = async (request: SearchEntitiesRequest): Promise<PaginatedResult<SearchResult>> => {
  return await httpGet<PaginatedResult<SearchResult>>(`api/search/${request.wildcard}`, request);
};

export { searchEntities };
